export const FAQ_CONSTANTS = {
  CONTACT_US: 'Contact Us',
  CONTACT_US_ID: 'contact-us',
  ZERO: '0',
};
